<div class="row">
  <div class="col-md-6">
    <form #bankInfoFormForm="ngForm" (ngSubmit)="onSubmit()" class="m-3">

      <div class="md-3 mb-3">
        <p *ngIf="!existsBankInfo" >No existe información Bancaria, porfavor Agregar</p>
      </div>

      <div class="md-3">
        <label for="bank" class="form-label fw-bold">Banco</label>
        <select class="form-select" id="bank" name="bankId" [(ngModel)]="bankInfoForm.bank" required
          #bankId="ngModel">
          <option [ngValue]="null" disabled>Seleccione un banco</option>
          <option *ngFor="let bank of banks" [value]="bank._id">{{ bank.name }}</option>
        </select>
        <div class="text-danger" *ngIf="bankId.invalid && bankId.touched">
          El banco es requerido.
        </div>
      </div>

      <div class="mb-3">
        <label for="accountType" class="form-label fw-bold">Tipo de Cuenta</label>
        <select class="form-select" id="accountType" name="bankAccountTypeId"
          [(ngModel)]="bankInfoForm.bank_account_type" required #bankAccountTypeId="ngModel">
          <option [ngValue]="null" disabled>Seleccione un tipo de cuenta</option>
          <option *ngFor="let type of bankAccountTypes" [value]="type._id">{{ type.name }}</option>
        </select>
        <div class="text-danger" *ngIf="bankAccountTypeId.invalid && bankAccountTypeId.touched">
          El tipo de cuenta es requerido.
        </div>
      </div>

      <div class="mb-3">
        <label for="accountNumber" class="form-label fw-bold">Número de Cuenta</label>
        <input type="text" id="accountNumber" name="accountNumber" class="form-control"
          [(ngModel)]="bankInfoForm.bank_account_number" required #accountNumber="ngModel" />
        <div class="text-danger" *ngIf="accountNumber.invalid && accountNumber.touched">
          El número de cuenta es requerido.
        </div>
      </div>


      <button type="submit" class="btn btn-sm btn-success" [disabled]="bankInfoFormForm.invalid"><i
        class="fa fa-save"></i>
        Guardar Cambios
      </button>

    </form>

  </div>
</div>